<template>
  <button
    class="sidebar-toggle-btn"
    @click="toggleSidebar"
    @mouseover="toggleSidebar"
    :class="{ expanded: isExpanded }"
    :title="isExpanded ? 'Contraer menú' : 'Expandir menú'"
  >
    <i class="material-icons toggle-icon">{{
      isExpanded ? "chevron_left" : "chevron_right"
    }}</i>
  </button>
</template>

<script>
export default {
  name: "SidebarToggle",
  data() {
    return {
      isExpanded: false,
    };
  },
  mounted() {
    // Verificar el estado inicial del sidebar
    this.checkSidebarState();
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleExpanded();
        this.isExpanded = this.$sidebar.isExpanded;
      }
    },
    checkSidebarState() {
      // Verificar si el sidebar está expandido
      this.isExpanded = this.$sidebar
        ? this.$sidebar.isExpanded
        : !document.body.classList.contains("sidebar-mini");
    },
  },
  watch: {
    // Escuchar cambios en la clase del body
    $route() {
      this.$nextTick(() => {
        this.checkSidebarState();
      });
    },
  },
};
</script>

<style scoped>
.sidebar-toggle-btn {
  position: fixed;
  bottom: 20px;
  left: 60px; /* Posicionado en el borde del sidebar */
  z-index: 10000;
  background: #2196f3;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  color: white;
  transform: translateX(-12px); /* Sobresale la mitad por fuera */
}

.sidebar-toggle-btn:hover {
  background: var(--bs-primary);
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.sidebar-toggle-btn:active {
  transform: scale(0.95);
}

.toggle-icon {
  font-size: 14px !important;
  transition: transform 0.3s ease;
}

.sidebar-toggle-btn.expanded .toggle-icon {
  transform: rotate(0deg);
}

.sidebar-toggle-btn:not(.expanded) .toggle-icon {
  transform: rotate(0deg);
}

/* Ajustar posición cuando el sidebar está expandido */
body:not(.sidebar-mini) .sidebar-toggle-btn {
  left: 260px; /* Posición cuando está expandido */
  transform: translateX(-12px);
}

/* Ajustar posición cuando el sidebar está contraído */
body.sidebar-mini .sidebar-toggle-btn {
  left: 80px; /* Posición cuando está contraído */
  transform: translateX(-12px);
}

/* Responsive */
@media (max-width: 991px) {
  .sidebar-toggle-btn {
    display: none;
  }
}
</style>
